export default function initRequiredCheckboxGroups() {
  const groupInputs = document.querySelectorAll<HTMLInputElement>('input[type="checkbox"][data-required-group]');
  const groups = new Map<string, HTMLInputElement[]>();

  groupInputs.forEach(input => {
    const list = groups.get(input.name) ?? [];
    list.push(input);
    groups.set(input.name, list);
  });

  groups.forEach(inputs => {
    const message = inputs[0].dataset.requiredMessage || 'Please select at least one option.';

    const validate = () => {
      const anyChecked = inputs.some(input => input.checked);
      inputs.forEach(input => input.setCustomValidity(anyChecked ? '' : message));
    };

    inputs.forEach(input => input.addEventListener('change', validate));
    validate();
  });
}
